export default __webpack_public_path__ + "static/media/1W_course1.b8d7dbfd.png";